import React from "react";
import { translate } from "lib";
import { ErrorBoundary } from "components/Shared";
import Actor from "components/Activities/Actor"
import Subject from "components/Activities/Subject"
import Context from "components/Activities/Context"
import ItemObject from "components/Activities/ItemObject"

const DeleteComment = ({ activity }: { activity: tcpinpoint.ActivityItem }) => <ErrorBoundary>
    <Actor actor={activity.attributes.item.actor} />{' '}
    {translate('removed')}{' '}
    <ItemObject object={activity.attributes.item.object} />
    <Subject subject={activity.attributes.item.subject} />
    <Context context={activity.attributes.item.context} />
</ErrorBoundary>

export default DeleteComment;